import Immutable from 'immutable';
import { combineReducers } from 'redux-immutablejs';

import comment from './CommentReducer';
import comments from './CommentsReducer';
import quotation from './QuotationReducer';
import quotations from './QuotationsReducer';
import summary from './SummaryReducer';
import summaries from './SummariesReducer';
import commentsTransactions from './CommentsTransactionsReducer';
import quotationsTransactions from './QuotationsTransactionsReducer';
import ratingsTransactions from './RatingsTransactionsReducer';
import tagsTransactions from './TagsTransactionsReducer';
import videosTransactions from './VideosTransactionsReducer';
import iOwnThisTransactions from './IOwnThisTransactionsReducer';
import similarTitlesTransactions from './SimilarTitlesTransactionsReducer';
import privateNotesTransactions from './PrivateNotesTransactionsReducer';
import contentAdvisoriesTransactions from './ContentAdvisoriesTransactionsReducer';
import ageSuitabilitiesTransactions from './AgeSuitabilitiesTransactionsReducer';
import summariesTransactions from './SummariesTransactionsReducer';
import tags from './TagsReducer';
import flagsTransactions from './FlagsTransactionsReducer';
import likes from './LikesReducer';

export default combineReducers(
  Immutable.Map({
    comment,
    comments,
    quotation,
    quotations,
    summary,
    summaries,
    commentsTransactions,
    quotationsTransactions,
    ratingsTransactions,
    tagsTransactions,
    videosTransactions,
    iOwnThisTransactions,
    similarTitlesTransactions,
    privateNotesTransactions,
    contentAdvisoriesTransactions,
    ageSuitabilitiesTransactions,
    summariesTransactions,
    tags,
    flagsTransactions,
    likes
  })
);
